<template>
  <footer class="common-footer" id="footer">
    <div v-if="appClass === 'hama'" style="text-align: center;">
      <h3>急を要するご相談は、通っている病院・主治医に直接ご相談ください</h3>
      <br>
    </div>
    <div v-if="!hiddenFooterFixedButton" class="fixed">
      <a href="/counselingDetail?createButton=true" class="fixed-button">相談してみる</a>
    </div>
    <ul class="footer-link">
      <li>
        <a href="/"><template v-if="appClass === 'hama'">浜松オンラインがん相談</template><template v-else>CancerWith</template>とは</a>
      </li>
      <li>
        <a href="/terms">利用規約</a>
      </li>
      <li>
        <a href="/privacy">プライバシーポリシー</a>
      </li>
      <li>
        <a href="/law">特定商取引法に基づく表示</a>
      </li>
      <li>
        <a href="https://zineinc.co.jp/">運営会社</a>
      </li>
      <li>
        <a href="https://zineinc.co.jp/#team">採用情報</a>
      </li>
      <li>
        <a v-bind:href="contactUrl">お問い合わせ/ご要望</a>
      </li>
      <li>
        <a href="/help">ヘルプ</a>
      </li>
    </ul>
    <ul class="footer-link">
      <li>
        <a href="https://cancerwith.com/blog/">Blog</a>
      </li>
      <li>
        <a href="https://twitter.com/cancerwithcom">Twitter</a>
      </li>
      <li>
        <a href="https://www.facebook.com/cancerwith/">Facebook</a>
      </li>
    </ul>
    <p class="footer-text">
      <template v-if="appClass === 'osaka'">
        地方独立行政法人 大阪府立病院機構 大阪国際がんセンター(AYA世代サポートチーム) / 株式会社ZINE<br>
      </template>
      <template v-else-if="appClass === 'hama'">
        共同運営：浜松医科大学 / 株式会社ZINE<br>
        株式会社ZINEは浜松市ファンドサポート事業の採択を受けた企業です<br>
      </template>
      Copyright (C) {{ now }} ZINE INC. All Rights Reserved.
    </p>
  </footer>
</template>
<script>
import { Common } from './Common.js'
export default {
  props: ['contactUrl', 'hiddenFooterFixedButton'],
  mixins:[Common],
  data: () => {
    return {
      now: '',
      contactUrl: '',
      hiddenFooterFixedButton: false,
      appClass: '',
    }
  },
  mounted : function(){
    this.appClass = this.getAppDivClass(location.hostname)
  },
  created() {
    const d = new Date()
    this.now = d.getFullYear()
    if (!this.contactUrl) {
      this.appClass = this.getAppDivClass(location.hostname)
      if (this.appClass === 'hama') {
        this.contactUrl = 'https://share.hsforms.com/1qOJQdDxdSbSqrkrMw8jeFA46sq5' // 浜松オンラインがん相談版
      } else {
        this.contactUrl = 'https://share.hsforms.com/1Bs-IcJO-TJOoLtoLHONvYQ46sq5' // CancerWith版
      }
    }
  }
}
</script>
<style>
</style>
